import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import useAdd from "../../api/useAdd";
import useFetchObjects from "../../api/useFetchObjects";
import { useTranslation } from "react-i18next";
import {
  getFormDirection,
  getRtlSelectProps,
  getRtlTextFieldProps,
} from "../utils/rtlForm";

const CurrencyAdd = ({ open, onClose, token }) => {
  const { t, i18n } = useTranslation();
  const formDirection = getFormDirection(i18n);
  const { fieldDirection } = formDirection;
  const selectProps = getRtlSelectProps(formDirection);
  const { handleAdd, loading, resetForm } = useAdd("shop/currencies", token);
  const { data: shopsData, loading: shopLoading } = useFetchObjects(
    ["shop"],
    "shop/shop",
    token
  );

  const shops = shopsData?.results || [];
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [selectedShop, setSelectedShop] = useState("");

  const handleSubmit = () => {
    const payload = {
      title: title.trim(),
      description: description.trim(),
      shop: selectedShop,
    };
    handleAdd(payload);
  };

  useEffect(() => {
    if (resetForm) {
      setTitle("");
      setDescription("");
      setSelectedShop("");
      onClose();
    }
  }, [resetForm, onClose]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" dir={fieldDirection}>
      <DialogTitle>{t("currency.addCurrency")}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate sx={{ mt: 1, direction: fieldDirection }}>
          <TextField
            autoFocus
            margin="dense"
            label={t("currency.title")}
            type="text"
            fullWidth
            required
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            {...getRtlTextFieldProps(formDirection)}
          />
          <TextField
            margin="dense"
            label={t("currency.description")}
            type="text"
            fullWidth
            multiline
            rows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            {...getRtlTextFieldProps(formDirection)}
          />
          <TextField
            select
            margin="dense"
            label={t("currency.selectShop")}
            fullWidth
            required
            value={selectedShop}
            onChange={(e) => setSelectedShop(e.target.value)}
            SelectProps={selectProps}
            {...getRtlTextFieldProps(formDirection)}
          >
            {shopLoading ? (
              <MenuItem value="">
                <CircularProgress size={20} />
              </MenuItem>
            ) : (
              (shops || []).map((shop) => (
                <MenuItem key={shop.id} value={String(shop.id)}>
                  {shop.name}
                </MenuItem>
              ))
            )}
          </TextField>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={loading}>
          {t("currency.cancel")}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={loading || !title.trim() || !selectedShop}
          sx={{ minWidth: 100 }}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            t("currency.submit")
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CurrencyAdd;
